import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from 'common/constants/signUp';
import { TermsAgreedProps } from './TermsAgreed.props';
import { termsAgreedClasses, TermsAgreedRoot } from './TermsAgreed.styles';

const TermsAgreed = ({ termsAgreed, setTermsAgreed }: TermsAgreedProps) => {
  const handleOnChangeTerms = () => setTermsAgreed((prevTermsAgreed: boolean) => !prevTermsAgreed);

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={termsAgreed}
          onChange={handleOnChangeTerms}
          name="terms_agreed"
          color="primary"
          disableRipple
        />
      }
      label={
        <TermsAgreedRoot className={termsAgreedClasses.termsAgreed}>
          By checking this box, you agree to Scalar's{' '}
          <a
            className={termsAgreedClasses.termsAgreedLinks}
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noopener noreferrer">
            Terms of Service
          </a>{' '}
          and confirm you have read Scalar's{' '}
          <a
            className={termsAgreedClasses.termsAgreedLinks}
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </TermsAgreedRoot>
      }
    />
  );
};

export default TermsAgreed;
